import React from "react"
import { JourneySomethingElseContainer } from "components/views/fle/journey/JourneySomethingElseContainer"

const JourneyLearnMoreSomethingElse = ({ history }) => (
  <JourneySomethingElseContainer
    title="Tell us what you want to learn more about."
    helperText="Being specific will allow us to better help you, if you’re comfortable sharing. We’ll follow up by email if we have more questions."
    history={history}
  />
)
export { JourneyLearnMoreSomethingElse }
